import axios from 'axios'
import langHelper from '@/helpers/langHelper'

export default ({ app: { context }, store: { getters } }, inject) => {
  let sistemaOperacional = 'Indeterminado'

  try {
    sistemaOperacional = navigator.platform
  } catch (_) {}

  const MULTISTORE_API_CLIENT = axios.create({
    baseURL: process.env.MULTISTORE_API,
    timeout: 10000,
    responseType: 'json',
    headers: {
      Accept: 'application/json'
    },
    params: {
      SistemaOperacional: sistemaOperacional
    }
  })

  MULTISTORE_API_CLIENT.interceptors.request.use((config) => {
    const defaultParams = {
      MobicarRequestorID: getters.getMobicarRequestorID,
      Locale: langHelper.parseLocaleToUnderline(getters.getLocale),
      RequestorDevice: 'Mobile',
      ClienteIP: getters.getUserIp
    }

    if (config.method.toLowerCase() === 'get') {
      config.params = { ...(config.params ?? {}), ...defaultParams }
    } else if (config.method.toLowerCase() === 'post') {
      config.data = { ...config.data, ...defaultParams, UsuarioEmissor: getters.getEmitterId }
    }

    return config
  })

  inject('multistoreApi', MULTISTORE_API_CLIENT)
}
